import { setNotification } from "../Notifications";
import axios from "axios";
import { deleteCookie, getCookie, setCookie } from "../cookie";
import { requestForToken, unregisterFCMToken } from "../firebase";
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
async function handleRequestCode(email) {
  // post a request to the user/auth path with the email in the body using axios fetch
  let response = 0;
  await axios
    .post(process.env.REACT_APP_API_URL + "/user/auth", { email: email })
    .then((res) => {
      // determine office locations
      let officeLocations = false;

      if (res.data.officeLocations && res.data.officeLocations.length > 0) {
        officeLocations = res.data.officeLocations.map((location) => {
          return {
            id: location._id,
            name: location.name,
          };
        });
      }
      response = {
        code: 200,
        type: res.data.type,
        officeLocations: officeLocations,
      };
    })
    .catch((err) => {
      if (err.code === "ERR_NETWORK") {
        response = { code: -2 };
      } else if (err.response && err.response.status === 400)
        response = {
          code: 400,
          message: JSON.parse(err.request.response).message,
        };
      else if (err.response && err.response.status === 500)
        response = {
          code: 500,
          message: "We've encountered a server error. Please try again later.",
        };
      else {
        response = {
          code: -1,
          message: "We've encountered an error. Please try again later.",
        };
      }
    });

  return response;
}

async function testEmailExists(email) {
  // post a request to the user/auth path with the email in the body using axios fetch
  let response = 0;
  await axios
    .post(process.env.REACT_APP_API_URL + "/user/verify-email", {
      email: email,
    })
    .then((res) => {
      // determine office locations

      response = {
        code: 200,
        registered: res.data.registered,
      };
    })
    .catch((err) => {
      if (err.code === "ERR_NETWORK") {
        response = { code: -2 };
      } else if (err.response && err.response.status === 400)
        response = {
          code: 400,
          message: JSON.parse(err.request.response).message,
        };
      else if (err.response && err.response.status === 500)
        response = {
          code: 500,
          message: "We've encountered a server error. Please try again later.",
        };
      else {
        response = {
          code: -1,
          message: "We've encountered an error. Please try again later.",
        };
      }
    });

  return response;
}

async function handleRequestRegister(token, email, userData) {
  // post a request to the user/auth path with the email in the body using axios fetch
  let response = 0;
  let body = {
    name: userData.name,
    email: email,
    key: token,
    surname: userData.surname,
    officeLocation: userData.location,
    timeOffset: new Date().getTimezoneOffset(),
  };
  await axios
    .post(process.env.REACT_APP_API_URL + "/user/register", body)
    .then((res) => {
      let user = res.data.user;
      let jwtToken = res.data.token;

      localStorage.setItem(
        "BTK-user",
        JSON.stringify({
          name: user.name,
          surname: user.surname,
          id: user._id,
          allowNotifications: user.allowNotifications,
          location: user.officeLocation._id,
          locationName: user.officeLocation.name,
          timeOffset: user.timeOffset,
          email: user.email,
        })
      );

      // set the jwt token cookie
      setCookie(process.env.REACT_APP_COOKIE_OBFUSCATE, jwtToken, 30);

      if (
        typeof Notification !== "undefined" &&
        Notification &&
        Notification.permission === "granted"
      ) {
        if (getCookie("is_debug_mode")) {
          setNotification("reqfortoken register");
        }
        requestForToken().then(async (token) => {
          if (token) await UpdateFCMToken(token);
        });
      } else if (getCookie("ios_token")) {
        if (getCookie("is_debug_mode")) {
          setNotification("has ios token");
        }
        UpdateFCMToken(getCookie("ios_token"));
      } else {
        setCookie("attempt_request_notification_2", "true", 1);
      }
    })
    .catch((err) => {
      if (err.code === "ERR_NETWORK") {
        response = { code: -2 };
      } else if (err.response && err.response.status === 400)
        response = JSON.parse(err.request.response);
      else if (err.response && err.response.status === 500)
        response = {
          message: "We've encountered a server error. Please try again later.",
        };
      else {
        response = {
          message: "We've encountered an error. Please try again later.",
        };
      }
    });

  return response;
}

async function handleRequestLogin(token, email) {
  let response = 0;
  await axios
    .post(process.env.REACT_APP_API_URL + "/user/login", {
      email: email,
      key: token,
    })
    .then((res) => {
      let user = res.data.user;
      let jwtToken = res.data.token;

      localStorage.setItem(
        "BTK-user",
        JSON.stringify({
          name: user.name,
          surname: user.surname,
          id: user._id,
          allowNotifications: user.allowNotifications,
          location: user.officeLocation._id,
          locationName: user.officeLocation.name,
          timeOffset: user.timeOffset,
          email: user.email,
        })
      );

      // set the jwt token cookie
      setCookie(process.env.REACT_APP_COOKIE_OBFUSCATE, jwtToken, 30);

      if (
        typeof Notification !== "undefined" &&
        Notification &&
        Notification.permission === "granted"
      ) {
        if (getCookie("is_debug_mode")) {
          setNotification("reqfortoken login");
        }
        requestForToken().then(async (token) => {
          if (token) await UpdateFCMToken(token);
        });
      } else if (getCookie("ios_token")) {
        if (getCookie("is_debug_mode")) {
          setNotification("has ios token");
        }
        UpdateFCMToken(getCookie("ios_token"));
      } else {
        setCookie("attempt_request_notification_2", "true", 1);
      }
    })
    .catch((err) => {
      if (err.code === "ERR_NETWORK") {
        response = { code: -2 };
      } else if (err.response && err.response.status === 400)
        response = JSON.parse(err.request.response);
      else if (err.response && err.response.status === 500)
        response = {
          message: "We've encountered a server error. Please try again later.",
        };
      else {
        response = {
          message: "We've encountered an error. Please try again later.",
        };
      }
    });

  return response;
}

async function RemoveAccount() {
  let response = 0;

  if (getCookie("ios_token")) {
    await deleteFCMToken();
  } else {
    try {
      const registration = await navigator.serviceWorker.getRegistration(
        "/firebase-messaging-sw.js"
      );

      const currentToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: registration,
      });

      if (currentToken) {
        await deleteFCMToken();
        await unregisterFCMToken();
        console.log("Calling deleteFCMToken");
      }
    } catch (err) {
      if (getCookie("is_debug_mode") === "true") {
        alert(JSON.stringify(err));
      }
    }
  }

  await axios
    .delete(process.env.REACT_APP_API_URL + "/user", {
      headers: {
        token: getCookie(process.env.REACT_APP_COOKIE_OBFUSCATE),
      },
    })
    .then((res) => {
      Object.keys(localStorage)
        .filter((x) => x.startsWith("BTK-"))
        .forEach((x) => localStorage.removeItem(x));
      deleteCookie(process.env.REACT_APP_COOKIE_OBFUSCATE);
      deleteCookie("notifications_blocked_2");
    })
    .catch((err) => {
      if (err.code === "ERR_NETWORK") {
        response = { code: -2 };
      } else if (err.response && err.response.status === 400)
        response = JSON.parse(err.request.response);
      else if (err.response && err.response.status === 500)
        response = {
          message: "We've encountered a server error. Please try again later.",
        };
      else {
        response = {
          message: "We've encountered an error. Please try again later.",
        };
      }
    });

  return response;
}

async function deleteFCMToken() {
  await UpdateFCMToken("", true);
}

async function UpdateFCMToken(token, allow_empty = false) {
  if (getCookie("is_debug_mode")) {
    setNotification("Sending fcm: " + token);
  }

  if (!token && !allow_empty) {
    return;
  }

  let response = 0;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/user/FCM",
      {
        token: token,
      },
      {
        headers: {
          token: getCookie(process.env.REACT_APP_COOKIE_OBFUSCATE),
        },
      }
    )
    .then((res) => {
      response = {
        code: 200,
        message: res.data,
      };
    })
    .catch((err) => {
      if (err.code === "ERR_NETWORK") {
        response = { code: -2 };
      } else if (err.response && err.response.status === 400)
        response = {
          code: err.response.status,
          message: JSON.parse(err.request.response),
        };
      else if (err.response && err.response.status === 500)
        response = {
          code: 500,
          message: "We've encountered a server error. Please try again later.",
        };
      else {
        response = {
          code: -1,
          message: "We've encountered an error. Please try again later.",
        };
      }
    });

  return response;
}

async function LogOut() {
  setNotification("Logged out. See you next time!");

  if (getCookie("ios_token")) {
    await deleteFCMToken();
  } else {
    try {
      const registration = await navigator.serviceWorker.getRegistration(
        "/firebase-messaging-sw.js"
      );

      const currentToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: registration,
      });

      if (currentToken) {
        await deleteFCMToken();
        await unregisterFCMToken();
        console.log("Calling deleteFCMToken");
      }
    } catch (err) {
      if (getCookie("is_debug_mode") === "true") {
        alert(JSON.stringify(err));
      }
    }
  }

  Object.keys(localStorage)
    .filter((x) => x.startsWith("BTK-"))
    .forEach((x) => localStorage.removeItem(x));

  deleteCookie(process.env.REACT_APP_COOKIE_OBFUSCATE);
  deleteCookie("notifications_blocked_2");
  deleteCookie("attempt_request_notification_2");
}

function isLoggedIn() {
  return getCookie(process.env.REACT_APP_COOKIE_OBFUSCATE) !== null;
}

export {
  isLoggedIn,
  LogOut,
  RemoveAccount,
  handleRequestCode,
  handleRequestRegister,
  handleRequestLogin,
  UpdateFCMToken,
  testEmailExists,
};
